import React from "react";
import styles from "./DetailLayout.module.css";
import backIcon from "../../assets/back.svg";

/* Detail container wrapper */
export function DetailContainer({ children }) {
  return <div className={styles.container}>{children}</div>;
}

/* Back navigation button with your custom SVG asset */
export function BackButton({ onClick }) {
  return (
    <button onClick={onClick} className={styles.backButton}>
      <img src={backIcon} alt="Back" className={styles.backButtonImg} />
    </button>
  );
}
